import {useContext} from 'react'
import { FieldExtensionSDK } from 'contentful-ui-extensions-sdk'
import sdkContext from '../../ExtensionContext'
export default () : {sdk?: FieldExtensionSDK, loading: boolean} => {
    const {sdk, loading} = useContext(sdkContext)
     return {sdk, loading}
}